import { IFpxBankList } from '@ddot/AddToCartCommon/lib/entities';
import { createAsyncThunk } from '@reduxjs/toolkit';

import Selectors from 'Redux/Selectors';

import { AsyncThunkAPI } from 'Redux/types';
import Actions from 'Redux/Actions';
import Atc from '../../../../Lib/ATC';

import { OrderErrorTypes } from '.';

export interface IGetCyberSourceInfoThunkParams {
    orderId: string;
}

export default createAsyncThunk<
    string,
    IGetCyberSourceInfoThunkParams,
    AsyncThunkAPI
>('order/getPaymentID', async (params, thunkAPI) => {
    const response = await thunkAPI.extra.useCases.order.getPaymentID.execute(params);

    if (response.status === Atc.UseCases.Types.UseCaseResponseStatus.Success) {
        return response.data;
    }

    if (response.data.type === OrderErrorTypes.GetCyberSourceInfoError.ServerError) {
        return thunkAPI.rejectWithValue(response.data.message || 'Something went wrong. Please try again.');
    }

    return thunkAPI.rejectWithValue('Something went wrong. Please try again.');
});
